import Vue from "vue";
import Popper from "popper.js";
import PopupManager from "element-ui/src/utils/popup/popup-manager";
const copy = require("copy-to-clipboard");
const vue = new Vue();

export default {
  install: function (Vue) {
    Vue.directive("selectTextOnFocus", {
      bind: function (el, binding) {
        function bindDom(el) {
          if (el.tagName !== "INPUT") {
            [...el.children].forEach((dom) => {
              bindDom(dom);
            });
          } else {
            el.onfocus = function () {
              setTimeout(() => {
                el.select();
              }, 30);
            };
            return true;
          }
        }

        bindDom(el);
      },
    });

    Vue.directive("clickOutSide", {
      bind: function (el, binding) {
        function onClick(e) {
          for (let { target } = e; target; target = target.parentNode) {
            if (target === el) {
              return;
            }
          }
          try {
            binding.value.fn();
          } catch (e) {
            throw new Error("请设置clickOutSide函数");
          }
          // el.parentNode.removeChild(el)
        }
        el.clickOutSide = onClick;
        document.addEventListener("click", el.clickOutSide);
      },
      unbind: function (el) {
        document.removeEventListener("click", el.clickOutSide);
      },
    });

    Vue.directive("removeMouseWheelEvent", {
      bind: function (el, binding) {
        el.onmousewheel = function (e) {
          // e.preventDefault()
          el.blur();
        };

        el.onkeydown = function (e) {
          if ([38, 40].includes(e.keyCode)) {
            e.preventDefault();
          }
        };
      },
    });
    // 防止重复提交
    Vue.directive("noMoreClick", {
      inserted(el, binding) {
        el.addEventListener("click", (e) => {
          let time = Number(binding.arg) || 2000;
          el.classList.add("is-disabled");
          el.disabled = true;
          setTimeout(() => {
            el.disabled = false;
            el.classList.remove("is-disabled");
          }, time);
        });
      },
    });

    Vue.directive("clickCopy", {
      bind: function (el, binding) {
        el.style.cursor = "pointer";
        el.setAttribute("title", el.getAttribute("title") || "点击复制");
        el.addEventListener("click", function () {
          copy(this.innerText);
          vue.$message({
            type: "success",
            message: "已复制到粘贴板",
            showClose: true,
          });
        });
      },
    });

    Vue.directive("numberAlign", {
      bind: function (el, binding, vNode, oldVNode, isDestroy) {
        // if (isDestroy) return
        // console.log(vNode.elm.innerHTML, (oldVNode.elm && oldVNode.elm.innerHTML))
        // if (vNode.elm.innerHTML === (oldVNode.elm && oldVNode.elm.innerHTML)) return
        const fixed = (binding.value && binding.value.fixed) || 2;
        const number = el.innerText.trim();
        number.replace(
          /^(-?)(\d+)(\.?)(\d+)?$/,
          function (match, $1, $2, $3, $4) {
            const wrapperContainer = document.createElement("span");
            vNode.key = Math.floor(Math.random() * 10000000) + Date.now();
            const leftEl = document.createElement("span");
            leftEl.innerText = $1 + $2;
            wrapperContainer.appendChild(leftEl);
            if ($1) {
              wrapperContainer.style.color = "#ee5b5b";
            }

            const rightEl = document.createElement("span");
            if (!$3) {
              rightEl.innerText = "." + "0".repeat(fixed);
              rightEl.style.visibility = "hidden";
              wrapperContainer.appendChild(rightEl);
            } else {
              rightEl.innerText = $3 + $4;
              if ($4.length < fixed) {
                const span = document.createElement("span");
                span.style.visibility = "hidden";
                span.innerText = "0".repeat(fixed - $4.length);
                rightEl.appendChild(span);
              }
              wrapperContainer.appendChild(rightEl);
            }

            el.innerHTML = "";
            el.appendChild(wrapperContainer);
          }
        );
      },
    });

    Vue.directive("inputNumberLimit", {
      bind: function (el, binding) {
        let positiveInteger = binding.value.positiveInteger ? "[1-9]" : "-?";
        let precision =
          binding.value.toFixed > 0
            ? `\\d{0,${binding.value.toFixed}}`
            : "\\d*";
        const reg = new RegExp(`^(${positiveInteger})(\\d*)(.?)(${precision})`);
        el.addEventListener("input", function () {
          this.value.replace(reg, (m, a, b, c, d) => {
            setTimeout(() => {
              this.value = a + b + c + d;
            }, 0);
          });
        });
      },
    });

    Vue.directive("scrollListen", {
      bind: function (el, binding) {
        let lastPotion = 0;
        let scrollWrap;
        if (binding.value && binding.value.el) {
          scrollWrap = el.querySelector(binding.value.el);
        } else {
          scrollWrap = el;
        }

        scrollWrap.onmousewheel = function () {
          const distanceRelativeToBottom =
            this.scrollHeight - this.scrollTop - this.clientHeight;
          if (distanceRelativeToBottom === 0) {
            try {
              binding.value.fn({
                direction: "down",
                scrollTop: this.scrollTop,
                distanceRelativeToBottom,
              });
            } catch (e) {
              console.log(e);
            }
          }
        };

        scrollWrap.onscroll = function () {
          const distanceRelativeToBottom =
            this.scrollHeight - this.scrollTop - this.clientHeight;
          const direction = getDirection(lastPotion, this.scrollTop);
          lastPotion = this.scrollTop;
          try {
            binding.value.fn({
              direction,
              scrollTop: this.scrollTop,
              distanceRelativeToBottom,
            });
          } catch (e) {
            console.log(e);
          }
        };

        function getDirection(last, now) {
          return now - last > 0 ? "down" : "up";
        }
      },
    });
    // 超过后浮框显示 v-textPopper:top.deep.innerHTML="'.clip'"
    // 新增深层选取，添加修饰符 deep 后，可以在表达式中传入选择器选择子元素，使用场景是：无法变动组件内部，但是可以通过外部样式修改内部元素的裁剪
    // 新增内容可以从innerHTML, innerText, value等取值，已被选中的具体元素为准，这需要用修饰符来指定
    // 新增可以使用 top，left, right, bottom 指令传参来指定显示位置
    Vue.directive("textPopper", {
      bind: function (el, binding) {
        if (binding.modifiers.deep) {
          const clipEle = el.querySelector(binding.value || ".clip");
          el = clipEle || el;
        }

        initTextPopper(el, binding.modifiers, binding.arg);
      },

      update: function (el, binding) {
        if (binding.modifiers.deep) {
          const clipEle = el.querySelector(binding.value || ".clip");
          el = clipEle || el;
        }
        if (el.popper) {
          el.popper.destroy();
          el.popper = null;
        }

        initTextPopper(el, binding.modifiers, binding.arg);
      },

      unbind: function (el, binding) {
        if (binding.modifiers.deep) {
          const clipEle = el.querySelector(binding.value || ".clip");
          el = clipEle || el;
        }
        if (el.popper) {
          el.popper.destroy();
          el.popper = null;
          el.onmouseover = null;
          el.onmouseout = null;
          el.popperDom = null;
        }
      },
    });

    Vue.directive("focus", {
      update: function (el) {
        el.focus();
      },
    });

    Vue.directive("scrollerStop", {
      update: function (el, binding) {
        const stopScroller = function () {
          el.onmousewheel = (e) => e.preventDefault();
          // el.addEventListener('mousewheel', stopScrollerFn, false)
        };

        const openScroller = function () {
          el.onmousewheel = (e) => {
            e.returnValue = true;
          };
          // el.removeEventListener('mousewheel', stopScrollerFn, false)
        };

        if (binding.value === true) {
          stopScroller();
        } else {
          openScroller();
        }
      },
    });

    /**
     * 输入框限制:
     * 输入框不能为number类型；
     * 输入值的应该是真实值做校验，不做处理；
     * update在所在组件内部状态变化就触发；
     */
    Vue.directive("inputLimit", {
      update: function (el, binding, vnode, oldVnode) {
        let status = true;
        let value = vnode.data.model["value"]; // 获取节点中的数据
        let oldValue = oldVnode.data.model["value"]; // 获取old节点中的数据
        if (value === oldValue) return; // 限制组件内部状态变化多次触发校验
        const args = binding.value.args; // filter所带的参数
        const filters = binding.value.filter;
        for (let i in filters) {
          let filter = filters[i];
          let type = Object.prototype.toString.call(filter);
          if (type === "[object Function]") {
            // 函数校验
            let params = null;
            if (args && args[i]) {
              params = args[i];
            }
            status = filter.call(null, value, params);
          } else if (type === "[object RegExp]") {
            // 正则校验
            status = filter.test(value);
          }
          if (!status) break;
        }
        if (!status && value !== "") {
          binding.value.fn.call(null, oldValue);
        }
      },
    });

    // 高亮指定字符串
    Vue.directive("highLight", {
      inserted(el, binding, vnode, oldVnode) {
        const disabled = binding.value.disabled;
        if (disabled) return false;
        const curColor = binding.value.color || "green";
        el.classList.add(`base-search_HIGHDOM-${curColor}`);
        const queryString = String(binding.value.queryString).trim();
        let value = el.innerHTML;

        if (value == "" || queryString == "") {
          return false;
        }
        const index = value.indexOf(queryString);
        if (index > -1) {
          // 高亮字符串
          const highDom = "<b>" + queryString + "</b>";
          value = value.replace(queryString, highDom);
          el.innerHTML = value;
        }
        return false;
      },
      componentUpdated(el, binding, vnode, oldVnode) {
        const disabled = binding.value.disabled;
        if (disabled) return false;
        el.classList.add("base-search_HIGHDOM");
        const queryString = String(binding.value.queryString).trim();
        let value = el.innerHTML.replace(/<\/?b>/g, "");

        if (value == "" || queryString == "") {
          return false;
        }
        const index = value.indexOf(queryString);
        if (index > -1) {
          // 高亮字符串
          const highDom = "<b>" + queryString + "</b>";
          value = value.replace(queryString, highDom);
          el.innerHTML = value;
        }
        return false;
      },
    });
  },
};

function initTextPopper(el) {
  el.onmouseover = function (event) {
    const wrapperWidth = event.currentTarget.clientWidth;
    const realWidth = event.currentTarget.scrollWidth;
    if (realWidth > wrapperWidth) {
      if (el.popper) {
        el.popperDom.style.display = "block";
        el.popper.update();
      } else {
        const wrapper = document.createElement("div");
        wrapper.style.zIndex = PopupManager.nextZIndex() + 1;
        wrapper.style.maxWidth = "260px"; // 保证一行最多显示15个字
        const div = document.createElement("div");
        div.style.background = "#fff";
        div.style.padding = "10px";
        div.style.borderRadius = "4px";
        div.style.boxShadow = "0px 1px 2px 2px rgba(0, 0, 0, .1)";
        div.style.wordBreak = "break-all";
        wrapper.appendChild(div);
        const i = document.createElement("i");
        i.className = "el-icon el-icon-caret-bottom";
        i.style.color = "#fff";
        i.style.left = "50%";
        i.style.fontSize = "20px";
        i.style.position = "absolute";
        i.style.bottom = "-12px";
        div.appendChild(i);
        const span = document.createElement("span");
        span.style.lineHeight = "24px";
        span.innerText = event.currentTarget.innerText;
        div.appendChild(span);
        document.body.appendChild(wrapper);
        el.popper = new Popper(event.currentTarget, wrapper, {
          placement: "top",
          removeOnDestroy: true,
          modifiers: {
            offset: {
              offset: "0,10px,0,0",
            },
          },
        });
        el.popperDom = wrapper;
      }
    }
  };

  el.onmouseout = function () {
    if (el.popperDom) {
      el.popperDom.style.display = "none";
    }
  };
}
